<template>
  <div>
    <v-card>
      <v-card-title></v-card-title>
      <v-card-text>
        <div class="mx-4 elevation-10 rounded-lg pa-4">
          <v-row class="ml-0">
            <v-col cols="12" sm="12" md="6" v-if="false">
              <div class="d-flex flex-column justify-start">
              <span class="subtitle-2 mr-2 mb-2">
                Rentang Tanggal
              </span>
                <DateRangePicker
                    opens="inline"
                    v-model="datePickerRange"
                    :locale-data="dprLocale"
                    @update="changeDatePickerRange"
                    :autoApply="dprAutoApply"
                    :showDropdowns="dprShowDropdowns"
                ></DateRangePicker>
              </div >
              <div class="d-flex mt-2">
                <v-spacer></v-spacer>
                <v-btn color="indigo" @click="reloadChartArea1('lastmonths')" small class="white--text">
                  Apply
                </v-btn>
              </div>
            </v-col>
            <v-col cols="12" sm="12" md="12">
              <div class="font-weight-black mb-2">TREND PENGUNJUNG</div>
              <div>
                <v-btn-toggle v-model="toggleValue" dense>
                  <v-btn
                      value="lastweeks"
                      @click="reloadChartArea1('lastweeks')"
                  >
                    <span class="caption font-weight-bold"
                    >1 Minggu Terakhir</span
                    >
                  </v-btn>
                  <v-btn
                      value="lastmonths"
                      @click="reloadChartArea1('lastmonths')"
                  >
                    <span class="caption font-weight-bold"
                    >1 Bulan Terakhir</span
                    >
                  </v-btn>
                  <v-btn
                      value="last6months"
                      @click="reloadChartArea1('last6months')"
                  >
                    <span class="caption font-weight-bold"
                    >6 Bulan Terakhir</span
                    >
                  </v-btn>

                  <v-btn
                      value="last12months"
                      @click="reloadChartArea1('last12months')"
                  >
                    <span class="caption font-weight-bold"
                    >Satu Tahun Terakhir</span
                    >
                  </v-btn>
                </v-btn-toggle>
              </div>
              <div>
                <apexcharts
                    type="area"
                    height="auto"
                    :options="chartOptionsBar1"
                    :series="seriesBar1"
                ></apexcharts>
              </div>
            </v-col>
          </v-row>
        </div>
      </v-card-text>
      <v-card-text >
        <div class="mx-4 elevation-10 rounded-lg pa-4">
          <v-row class="ml-0 py-4 px-4">
            <v-col cols="12" sm="12" md="12">
              <div>
                <v-form v-model="valid">
                  <v-row>
                    <v-spacer></v-spacer>
                    <v-col cols="12" sm="12" md="2">
                      <v-autocomplete
                          outlined
                          v-model="year"
                          :items="itemsYear"
                          :rules="rulesNotEmtpy"
                          item-value="id"
                          item-text="text"
                          auto-select-first
                          dense
                          chips
                          deletable-chips
                          color="blue-grey lighten-2"
                          single-line
                      ></v-autocomplete>
                    </v-col>
                    <v-col cols="12" sm="12" md="2">
                      <v-btn :disabled="!valid" block class="white--text" color="indigo" @click="calculateVisitor(year)">
                        Tampilkan
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-form>
              </div>
              <div class="font-weight-bold text-center text-h5 my-3">
                TOTAL PENGUNJUNG TAHUN <span class="orange--text">{{yearText}}</span>
              </div>
              <v-data-table
                  :headers="headers"
                  :items="fVisitorsFiltered"
                  hide-default-footer
                  class="elevation-0"
              >

              </v-data-table>
            </v-col>
          </v-row>
        </div>
      </v-card-text>
      <v-card-text>
        <div class="mx-4 elevation-10 rounded-lg pa-4">
          <v-row class="ml-0">
            <v-col cols="12" sm="12" md="12">
              <div class="font-weight-bold">TOTAL PENGUNJUNG</div>
              <apexcharts
                  type="bar"
                  height="500"
                  :options="chartOptionsBar3"
                  :series="seriesBar3"
              ></apexcharts>
            </v-col>
            <v-col cols="12" sm="12" md="6">
              <div class="font-weight-bold">TOTAL PENGUNJUNG BERDASARKAN KOTA</div>
              <apexcharts
                  width="500"
                  height="250"
                  :options="chartOptionsPie1"
                  :series="seriesPie1"
              ></apexcharts>
            </v-col>
            <v-col cols="12" sm="12" md="6">
              <div class="font-weight-bold">TOTAL PENGUNJUNG BERDASARKAN NEGARA</div>
              <apexcharts
                  width="500"
                  height="250"
                  :options="chartOptionsPie2"
                  :series="seriesPie2"
              ></apexcharts>
            </v-col>
          </v-row>
          <div class="d-flex">
            <v-spacer></v-spacer>
            <v-btn color="success" small @click="reloadChart">
              <v-icon small>mdi-refresh</v-icon>
              Refresh
            </v-btn>
          </div>
        </div>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import VueApexCharts from "vue-apexcharts";
import FVisitorService from "../../services/apiservices/f-visitor-service";
import DateRangePicker from 'vue2-daterange-picker'
import 'vue2-daterange-picker/dist/vue2-daterange-picker.css'

export default {
  name: "ChartVisitorDialogContent",
  components: { apexcharts: VueApexCharts, DateRangePicker },
  props: {},
  data() {
    return {
      toggleValue: "",
      fVisitorsFiltered: [],
      headers: [
        {text: 'Januari', value: 'january', align: 'center', sortable: false},
        {text: 'Februari', value: 'february', align: 'center', sortable: false},
        {text: 'Maret', value: 'march', align: 'center', sortable: false},
        {text: 'April', value: 'april', align: 'center', sortable: false},
        {text: 'Mei', value: 'may', align: 'center', sortable: false},
        {text: 'Juni', value: 'june', align: 'center', sortable: false},
        {text: 'Juli', value: 'july', align: 'center', sortable: false},
        {text: 'Agustus', value: 'august', align: 'center', sortable: false},
        {text: 'September', value: 'september', align: 'center', sortable: false},
        {text: 'Oktober', value: 'october', align: 'center', sortable: false},
        {text: 'November', value: 'november', align: 'center', sortable: false},
        {text: 'Desember', value: 'december', align: 'center', sortable: false},
      ],
      rulesNotEmtpy: [(v) => !!v || "Tidak boleh kosong"],
      valid:false,
      year: new Date().getFullYear(),
      yearText: new Date().getFullYear(),
      itemsYear: [
        {id: 2023, text: '2023'},
        {id: 2024, text: '2024'},
        {id: 2025, text: '2025'},
        {id: 2026, text: '2026'},
        {id: 2027, text: '2027'},
        {id: 2028, text: '2028'},
        {id: 2029, text: '2029'},
        {id: 2030, text: '2030'},
      ],
      series: [
        {
          name: "City",
          data: [44, 55, 41, 67, 22],
        },
      ],
      seriesBar1: [
        {
          name: "City",
          data: [44, 55, 41, 67, 22],
        },
      ],
      seriesBar2: [
        {
          name: "City",
          data: [44, 55, 41, 67, 22],
        },
      ],
      seriesBar3: [
        {
          name: "City",
          data: [44, 55, 41, 67, 22],
        },
      ],

      categoriesBar1: [],
      chartOptionsBar1: {
        chart: {
          height: 1000,
          type: "bar",
        },
      },
      categoriesBar2: [],
      chartOptionsBar2: {
        chart: {
          height: 300,
          type: "bar",
        },
      },
      categoriesBar3: [],
      chartOptionsBar3: {
        chart: {
          height: 300,
          type: "bar",
          horizontal: true,
        },
      },

      chartOptionsPie1: {
        chart: {
          height: 500,
          type: "pie",
        },
      },
      chartOptionsPie2: {
        chart: {
          height: 500,
          type: "pie",
        },
      },
      labelsPie1: [
        "A",
        "B",
        "C",
        "D",
        "E",
        "F",
        "G",
        "H",
        "I",
        "J",
        "K",
        "L",
        "M",
        "N",
        "O",
      ],
      seriesPie1: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 12, 13, 14, 15],
      labelsPie2: [
        "A",
        "B",
        "C",
        "D",
        "E",
        "F",
        "G",
        "H",
        "I",
        "J",
        "K",
        "L",
        "M",
        "N",
        "O",
      ],
      seriesPie2: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 12, 13, 14, 15],

      datePickerRange: {
        startDate: function(d){ d.setMonth(d.getMonth() - 1); return d}(new Date),
        endDate: new Date(),
      },
      dprLocale: {
        direction: 'ltr', //direction of text
        format: 'dd/mm/yyyy',
        separator: ' - ', //separator between the two ranges
        applyLabel: 'Terapkan',
        cancelLabel: 'Batal',
        weekLabel: 'W',
        customRangeLabel: 'Custom Range',
        // daysOfWeek: moment.weekdaysMin(), //array of days - see moment documenations for details
        // monthNames: moment.monthsShort(), //array of month names - see moment documenations for details
        firstDay: 1, //ISO first day of week - see moment documenations for details
      },
      dprAutoApply:true,
      dprShowDropdowns:true,
      opens:true,
      showDropdowns:true,
    };
  },
  watch: {
    seriesBar1: {
      handler: function (value) {
        if (value) this.reloadChartOptionBar1();
      },
    },
  },
  computed: {},
  methods: {
    changeDatePickerRange(){
      // console.log(`${this.datePickerRangeInv.startDate} >> ${this.datePickerRangeInv.endDate}`)
    },
    reloadChart() {
      this.reloadChartArea1('lastmonths');
      this.reloadChartArea2();
      this.reloadChartArea3();
      this.reloadChartPie1();
      this.reloadChartPie2();
    },

    calculateVisitor(year){
      this.fVisitorsFiltered = []
      let yearInt = parseInt(year)
      let startDateLong = new Date(yearInt - 1, 12, 1).getTime();
      let endDateLong = new Date(yearInt, 12, 31).getTime();
      FVisitorService.getVisitorCountByCityAndMonth(startDateLong, endDateLong).then((response) => {
        this.yearText = yearInt
        this.fVisitorsFiltered.push({
          id: 1,
          january: 0,
          february: 0,
          march: 0,
          april: 0,
          may: 0,
          june: 0,
          july: 0,
          august: 0,
          september: 0,
          october: 0,
          november: 0,
          december: 0
        });

        response.data.forEach(item => {
          if (item.month === 1 && item.year === yearInt) this.fVisitorsFiltered[0].january += item.totalVisitorCount;
          if (item.month === 2 && item.year === yearInt) this.fVisitorsFiltered[0].february += item.totalVisitorCount;
          if (item.month === 3 && item.year === yearInt) this.fVisitorsFiltered[0].march += item.totalVisitorCount;
          if (item.month === 4 && item.year === yearInt) this.fVisitorsFiltered[0].april += item.totalVisitorCount;
          if (item.month === 5 && item.year === yearInt) this.fVisitorsFiltered[0].may += item.totalVisitorCount;
          if (item.month === 6 && item.year === yearInt) this.fVisitorsFiltered[0].june += item.totalVisitorCount;
          if (item.month === 7 && item.year === yearInt) this.fVisitorsFiltered[0].july += item.totalVisitorCount;
          if (item.month === 8 && item.year === yearInt) this.fVisitorsFiltered[0].august += item.totalVisitorCount;
          if (item.month === 9 && item.year === yearInt) this.fVisitorsFiltered[0].september += item.totalVisitorCount;
          if (item.month === 10 && item.year === yearInt) this.fVisitorsFiltered[0].october += item.totalVisitorCount;
          if (item.month === 11 && item.year === yearInt) this.fVisitorsFiltered[0].november += item.totalVisitorCount;
          if (item.month === 12 && item.year === yearInt) this.fVisitorsFiltered[0].december += item.totalVisitorCount;
        });
      })
    },

    reloadChartArea1(param) {
      this.categoriesBar1 = [];
      this.seriesBar1 = [];
      let dateNow = new Date();
      let lastMonthAgo = 1;
      let startDateLong = new Date(dateNow.getFullYear(), dateNow.getMonth() - lastMonthAgo, 1).getTime();
      let endDateLong = dateNow.getTime();
      let thisMonthFrom1 = dateNow.getMonth() + 1;
      let startMonth = Math.max(1, thisMonthFrom1 - lastMonthAgo);
      const monthNames = [
        "January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"
      ];

      for (let i = startMonth; i <= thisMonthFrom1; i++) {
        this.categoriesBar1.push('*');
      }

      if (param === 'lastweeks') {
        startDateLong = new Date(dateNow.getFullYear(), dateNow.getMonth(), dateNow.getDate() - 7).getTime();
      } else if (param === 'lastmonths') {
        startDateLong = new Date(dateNow.getFullYear(), dateNow.getMonth() - 1, 1).getTime();
        this.categoriesBar1 = [];
        for (let i = 1; i >= 0; i--) {
          const monthIndex = (dateNow.getMonth() - i + 12) % 12;
          this.categoriesBar1.push(monthNames[monthIndex]);
        }
      } else if (param === 'last6months') {
        startDateLong = new Date(dateNow.getFullYear(), dateNow.getMonth() - 6, 1).getTime();
        this.categoriesBar1 = [];
        for (let i = 5; i >= 0; i--) {
          const monthIndex = (dateNow.getMonth() - i + 12) % 12;
          this.categoriesBar1.push(monthNames[monthIndex]);
        }
      } else if (param === 'last12months') {
        startDateLong = new Date(dateNow.getFullYear(), dateNow.getMonth() - 12, 1).getTime();
        this.categoriesBar1 = [];
        for (let i = 11; i >= 0; i--) {
          const monthIndex = (dateNow.getMonth() - i + 12) % 12;
          this.categoriesBar1.push(monthNames[monthIndex]);
        }
      }

      FVisitorService.getVisitorCountByCityAndMonth(startDateLong, endDateLong).then((response) => {
        let uniqueCity = [...new Set(response.data.map((item) => item.city))];
        this.seriesBar1 = [];

        uniqueCity.forEach((x) => {
          let theName = x;
          let theData = [];

          if(param === 'last6months' || param === 'last12months'){
            for (let i = 0; i < this.categoriesBar1.length; i++) {
              const currentMonthName = this.categoriesBar1[i];
              const currentMonthIndex = monthNames.indexOf(currentMonthName);
              const arr = response.data.filter((f) => f.city === x && f.month === (currentMonthIndex + 1));

              if (arr.length > 0) theData.push(arr[0].totalVisitorCount);
              else theData.push(0);
            }
          } else if (param === 'lastmonths' || param === 'lastweeks'){
            for (let i = 0; i < this.categoriesBar1.length; i++) {
              const arr = response.data.filter((f) => f.city === x && f.month === (i + 1));
              if (arr.length > 0) theData.push(arr[0].totalVisitorCount);
              else theData.push(0);
            }
          }

          this.seriesBar1.push({
            name: theName,
            data: theData,
          });
        });

        this.reloadChartOptionBar1();
      });
    },

    reloadChartArea2() {
      let dateNow = new Date();
      let lastWeekAgo = 5;
      let startDateLong = new Date(
          dateNow.getFullYear(),
          dateNow.getMonth() - lastWeekAgo,
          dateNow.getDate() - lastWeekAgo * 7
      ).getTime();
      let endDateLong = dateNow.getTime();

      let thisWeekNumber = this.getWeekNumber(dateNow);
      FVisitorService.getVisitorCountByCityAndWeek(
          startDateLong,
          endDateLong
      ).then((response) => {

        this.categoriesBar2 = [];
        for (let i = thisWeekNumber - lastWeekAgo; i <= thisWeekNumber; i++) {
          this.categoriesBar2.push(i);
        }

        let uniqueCity = [...new Set(response.data.map((item) => item.city))];
        this.seriesBar2 = [];
        uniqueCity.forEach((x) => {
          let theName = x;
          let theData = [];

          for (let i = thisWeekNumber - lastWeekAgo; i <= thisWeekNumber; i++) {
            const arr = response.data.filter(
                (f) => f.city === x && f.week === i
            );
            if (arr.length > 0) theData.push(arr[0].totalVisitorCount);
            else theData.push(0);
          }
          this.seriesBar2.push({
            name: theName,
            data: theData,
          });
        });

        this.reloadChartOptionBar2();
      });
    },
    reloadChartArea3() {
      FVisitorService.countVisitorByCity().then((response) => {
        let rawData = response.data;

        rawData.sort((a, b) => b.totalVisitorCount - a.totalVisitorCount);
        let topCount = 10;
        let topCities = rawData.slice(0, topCount);
        let otherTotal = rawData
            .slice(topCount)
            .reduce((sum, item) => sum + item.totalVisitorCount, 0);
        if (otherTotal > 0) {
          topCities.push({ city: "Lainnya", totalVisitorCount: otherTotal });
        }
        this.categoriesBar3 = topCities.map((item) => item.city);
        this.seriesBar3 = [
          {
            data: topCities.map((item) => item.totalVisitorCount),
          },
        ];

        this.reloadChartOptionBar3();
      });
    },
    reloadChartPie1() {
      FVisitorService.countVisitorByCity().then((response) => {
        let rawData = response.data;
        console.log('City',rawData);
        rawData.sort((a, b) => b.totalVisitorCount - a.totalVisitorCount);

        let topCount = 10;
        let topCities = rawData.slice(0, topCount);

        let otherTotal = rawData
            .slice(topCount)
            .reduce((sum, item) => sum + item.totalVisitorCount, 0);

        if (otherTotal > 0) {
          topCities.push({ city: "Lainnya", totalVisitorCount: otherTotal });
        }

        this.labelsPie1 = topCities.map((item) => item.city);
        this.seriesPie1 = topCities.map((item) => item.totalVisitorCount);
        this.reloadChartOptionPie1();
      });
    },
    reloadChartPie2() {
      FVisitorService.countVisitorByCountry().then((response) => {
        let rawData = response.data;
        let countryMap = {};

        rawData.forEach((item) => {
          let countryName = item.country ? item.country.trim() : "Lainnya"; // Jika kosong, jadi "Lainnya"

          if (countryMap[countryName]) {
            countryMap[countryName] += item.totalVisitorCount;
          } else {
            countryMap[countryName] = item.totalVisitorCount;
          }
        });

        let mergedData = Object.entries(countryMap).map(([country, totalVisitorCount]) => ({
          country,
          totalVisitorCount,
        }));

        mergedData.sort((a, b) => b.totalVisitorCount - a.totalVisitorCount);

        let topCount = 5;
        let topCountry = mergedData.slice(0, topCount);

        this.labelsPie2 = topCountry.map((item) => item.country);
        this.seriesPie2 = topCountry.map((item) => item.totalVisitorCount);
        this.reloadChartOptionPie2();
      });
    },
    reloadChartOptionBar1() {
      this.chartOptionsBar1 = {
        chart: {
          height: 400,
          type: "area",
          background: "#f8f8f8", // Warna latar belakang grafik
        },
        plotOptions: {
          bar: {
            borderRadius: 10,
            columnWidth: "50%",
            horizontal: false,
          },
        },
        dataLabels: {
          enabled: false,
        },
        stroke: {
          width: 3,
          curve: "smooth",
        },
        grid: {
          row: {
            colors: ["#fff", "#f2f2f2"],
          },
        },
        xaxis: {
          labels: {
            rotate: -45,
          },
          categories: this.categoriesBar1,
          title: {
            text: "",
          },
          tickPlacement: "on",
        },
        yaxis: {
          title: {
            text: "Jumlah Pengunjung",
          },
        },
        tooltip: {
          theme: "dark",
        },
      };
    },

    reloadChartOptionBar2() {
      this.chartOptionsBar2 = {
        chart: {
          height: 300,
          type: "area",
          background: "#f8f8f8", // Warna latar belakang grafik
        },
        plotOptions: {
          bar: {
            borderRadius: 10,
            columnWidth: "50%",
            horizontal: false,
          },
        },
        dataLabels: {
          enabled: false,
        },
        stroke: {
          width: 3,
          curve: "smooth",
        },
        grid: {
          row: {
            colors: ["#fff", "#f2f2f2"],
          },
        },
        xaxis: {
          labels: {
            rotate: -45,
          },
          categories: this.categoriesBar2,
          title: {
            text: "Minggu ke-",
          },
          tickPlacement: "on",
        },
        yaxis: {
          title: {
            text: "Jumlah Pengunjung",
          },
        },
        tooltip: {
          theme: "dark",
        },
      };
    },

    reloadChartOptionBar3() {
      this.chartOptionsBar3 = {
        chart: {
          type: "bar",
          height: 350,
        },
        plotOptions: {
          bar: {
            borderRadius: 4,
            horizontal: true,
          },
        },
        dataLabels: {
          enabled: false,
        },
        xaxis: {
          categories: this.categoriesBar3,
          title: {
            text: "Jumlah Pengunjung",
          },
        },
      };
    },

    reloadChartOptionPie1() {
      this.chartOptionsPie1 = {
        chart: {
          width: 500,
          type: "pie",
        },
        labels: this.labelsPie1,
        fill: {
          type: "gradient",
        },

        responsive: [
          {
            breakpoint: 480,
            options: {
              chart: {
                width: 500,
                type: "pie",
              },
              legend: {
                position: "bottom",
              },
            },
          },
        ],
      };
    },
    reloadChartOptionPie2(){
      this.chartOptionsPie2 = {
        chart: {
          width: 500,
          type: "pie",
        },
        labels: this.labelsPie2,
        fill: {
          type: "gradient",
        },

        responsive: [
          {
            breakpoint: 480,
            options: {
              chart: {
                width: 500,
                type: "pie",
              },
              legend: {
                position: "bottom",
              },
            },
          },
        ],
      };
    },
    getWeekNumber(date) {
      const d = new Date(date);
      d.setHours(0, 0, 0, 0);
      d.setDate(d.getDate() + 4 - (d.getDay() || 7));
      const yearStart = new Date(d.getFullYear(), 0, 1);
      const weekNumber = Math.ceil(((d - yearStart) / 86400000 + 1) / 7);
      return weekNumber;
    },
  },
  mounted() {
    this.reloadChartArea1('lastmonths');
    this.reloadChartArea2();
    this.reloadChartArea3();
    this.reloadChartPie1();
    this.reloadChartPie2();
    this.calculateVisitor(this.year);
  },
};
</script>

<style scoped>
</style>